import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIDataProvider, TApiResponse, ApiPaths } from '../../api';
import { ISection } from '../V2/SectionSlice';
import { ILessonTutorFeedback } from '../V2/LessonTutorFeedbacksSlice';
import { ILessonHistory } from '../V2/LessonHistorySlice';

export interface IStartTrial {
  email: string;
}

interface ITrialUser {
  id: string;
  firstName: string;
  lastName: string;
  userName: string;
  email: string;
  quizRole: string;
  isQuiztopiyaPendingTrial: boolean;
  assessmentEngineDate: string;
  quiztopiyaTrialExpiration: string;
}

const apiDataProvider = new APIDataProvider();

export const startTrial = createAsyncThunk(
  'user/trials/createFromQuiztopiya',
  async (data: IStartTrial) => {
    const response = await apiDataProvider.post<TApiResponse<ITrialUser>>(
      `${ApiPaths.trials}/createFromQuiztopiya`,
      data
    );

    return response.data;
  }
);

export const getTrial = createAsyncThunk(
  '/trials/quiztopiya-trial-recordings/id',
  async (id: string) => {
    const response = await apiDataProvider.get<
      TApiResponse<{
        sectionData: ISection;
        tutorFeedback?: ILessonTutorFeedback;
        lessonHistory?: ILessonHistory;
      }>
    >(`${ApiPaths.trials}/quiztopiya-trial-recordings/${id}`);

    return response.data;
  }
);

export default startTrial;
